import { MDBAlert, MDBBtn, MDBDatatable, MDBIcon, MDBInput, MDBModal, MDBModalBody, MDBModalContent, MDBModalDialog, MDBModalHeader, MDBModalTitle, MDBSpinner } from "mdb-react-ui-kit";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router";
import { getAssociatedCFData, getHuntsgroups } from "../../apiclients/streamsapi_bridge";
import PopupLoader from "../../views/popups/PopupLoader";
import AddHuntGroup from "../../views/popups/hunt/AddHuntGroup";
import DeleteHuntGroup from "../../views/popups/hunt/DeleteHungGroup";
import { formattedNumber } from "../../views/popups/phonenumbers/AddRemoveNumbers";
import { Tooltip } from "react-tooltip";
import PopupLoaderNew from "../../views/popups/PopupLoaderNew";
import { customSearch, useAutoFocusSearchAfterLoads } from "../CustomSearchUtil/CustomSearch";
import UIConstant from "../../apiclients/UIConstant";
import TabIDConstant from "../../apiclients/TabIDConstant";
import ImportProgressWarning from "../../apiclients/ImportProgressWarning";
import { getImpExpStatusNew } from "../../apiclients/CommonUtils";
import ImpExpRedirectPopup from "../../apiclients/ImpExpRedirectPopup";
import ImportUser from "../editviews/user/ImportUser";
export default function HuntGroups(props) {
  /***************************************************************************************************** */
  /**
   * Declarations of constants with their state
   */
  const location = useLocation();
  const { t, i18n } = useTranslation();
  const [addHundGroup, setAddHundGroup] = useState(location.state ? location.state.openadd : false);
  const [huntgroups, setHuntgroups] = useState([]);
  const navigate = useNavigate();
  const [deleteHGroup, setDeleteHGroup] = useState(false);
  const [selectedGroupId, setSelectedGroupId] = useState();
  const [isloading, setIsloading] = useState(false);
  const [internalError, setInternalError] = useState(false);
  const [assocCallFlows, setAssocCallFlows] = useState([]);
  const [assocLunaHops, setassocLunaHops] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [filteredRows, setFilteredRows] = useState([]);
  const [HuntGroupDetails, setHuntGroupDetails] = useState([]);
  const [showExportWarning, setShowExportWarning] = useState(false);
  const [dataLoaded, setDataLoaded] = useState(false); // flag

      const exportwarningToggle = () => setShowExportWarning(!showExportWarning);
  const [warningMessage, setWarningMessage] = useState("");
  const [showImpExpRedirect, setShowImpExpRedirect] = useState(false);
  const [importUser, setimportUser] = useState(false);
  const importuserToggle = () => setimportUser(!importUser);
  const [firstRequest, setfirstRequest] = useState(false);
  /*****************************************************************************************************
  /**
   * functions for internal actions
   * 
   */
  const togglePopup = () => setAddHundGroup(!addHundGroup);
  const dtogglePopup = () => setDeleteHGroup(!deleteHGroup);
  const addHuntRef = useRef(null);
  const [isLoading, setisLoading] = useState(false);
  const searchRef = useRef(null);

   useAutoFocusSearchAfterLoads(dataLoaded,setDataLoaded,searchRef)

  function handleClick() {
    addHuntRef.current.click();
  }

  async function fetchHGroupData() {
    try {
      sessionStorage.setItem("current_link", "huntgroup");
      setIsloading(true);
      setInternalError(false);
      const response = await getHuntsgroups(
        JSON.parse(sessionStorage.getItem("admin_session")).siteid,
        TabIDConstant.HUNT_GRP_LINK
      );
      const rawData = await response.json();
      if (response.status === 200) {
        setHuntgroups(rawData?.groups ?? []);
      } else if (response.status === 500) {
        setInternalError(true);
      } else {
        navigate("/");
      }
    } catch (e) {
      console.log(`Unable to process the request:${e}`);
      setInternalError(true);
    } finally {
      setIsloading(false);
    }

  }

  async function deletethisGroup(evntData, groupId) {
    evntData.preventDefault();
    evntData.stopPropagation();
    // fetching the associated CF information
    let associatedCF = await getAssocCFDataByEntityIdNodeType(JSON.parse(sessionStorage.getItem("admin_session")).siteid, groupId, 2 );

    setAssocCallFlows(associatedCF?.associated_callflows ?? []);
    setassocLunaHops(associatedCF?.associated_luna_hops ?? []);
    setSelectedGroupId(groupId);
    setDeleteHGroup(true);
  }


useEffect(()=>{
let proccessdRows = [];
  huntgroups.map((group) => {
    let phNumber = group.phnumber ? formattedNumber(group.phnumber) + "" : ""
    proccessdRows.push({
      hgInfo: group,
      name: group.title,
      extension: group.extensions,
      phnumber: group.phnumber_count > 1 ? phNumber + ", ...": phNumber,
      actualNumber: phNumber?.toString().replace(/[ ]/g, ''),
      number: group.phnumber + "" ?? "",
      location: group.location_name,
      delete: (
        <>
          {/* 
          <a className="ms-3"
            style={{ zIndex: 99996 }}
            href="#"
            onClick={(e) => deletethisGroup(e, group.code)}
            target="_new"
          >
            <MDBIcon fas icon="times" className="green" title="Remove" />
          </a> */}

          <div className="d-flex align-items-center justify-content-center">
            <div className="custom-hover-bg p-1 cursor-pointer deleteToolTip" onClick={(e) => deletethisGroup(e, group.code)}>
              <MDBIcon fas icon="times" color="primary" className="mx-2 fs-5" />
            </div>
          </div>
        </>
      )
    });
  });
  setFilteredRows(proccessdRows);
  setHuntGroupDetails(proccessdRows)
  setDataLoaded(true);
  },[huntgroups])

  const handleManualSearch = (searchValue) => {
    setSearchValue(searchValue);
    const filtered = customSearch(HuntGroupDetails, searchValue,UIConstant.HUNT_GROUPS);

    setFilteredRows(filtered);
  };

  const finalData = {
    columns: [
      { label: "Name", field: "name", sort: true },
      { label: "Extension", field: "extension", sort: true },
      { label: "Phone Numbers", field: "phnumber" },
      { label: "Location", field: "location" },
      { label: "Remove", field: "delete", sort: false },
    ],
    rows: HuntGroupDetails,
  };
  function showThisInfo(tdata) {
    navigate("/huntaccinfo", {
      state: tdata.hgInfo,
    });
  }
  useEffect(() => {
    fetchHGroupData();
  }, []);
  useEffect(() => {
    if (location.state?.openadd) {
      setAddHundGroup(true);
      navigate("/huntgroup", { replace: true, state: {} }); // Reset state immediately
    }
  }, [location.state]);

  const handleImportAndPrgress = async(e) => {
    e.preventDefault();
    const result = await getImpExpStatusNew();
    if (result.status === 0) {
      togglePopup();
    } else if (result.isOwnUser) {
      setShowImpExpRedirect(true);
    } else {
      const { userInfo } = result;
      if (userInfo?.isaccount) {
        setWarningMessage(t("imp_exp_account_progress", { name: userInfo.name ?? "" }));
      } else {
        setWarningMessage(t("imp_exp_other_user_progress", { name: userInfo?.name ?? "" }));
      }
      exportwarningToggle();
    }
  }
  
  /*****************************************************************************************************
  /**
   * Return HTML view
   */
  return (
    <>
      <div className=" dblock">
        <div className="d-flex justify-content-between actionbar">
          <div className="input-group w-25"></div>
          <div>
            <MDBBtn onClick={(e) => handleImportAndPrgress(e)}><MDBIcon fas icon="plus" className="me-2" />{t("addHuntGroup")}</MDBBtn>
          </div>
        </div>
            <div className='mb-2 mt-0 position-relative w-auto'>
              <MDBInput 
                label="Search" 
                value={searchValue} 
                ref={searchRef}
                onChange={(e) => handleManualSearch(e.target.value)} 
              />
              <MDBIcon fas icon="search" className='MDBDatatable-Search' />
            </div>
        <div className="input-group rounded w-100 dblock huntDataTable">
          <MDBDatatable key={searchValue} className="actioncolumn"
            onRowClick={(event, rowData) => {
              showThisInfo(event);
            }}
            // search
            fixedHeader
            sortField="Name"
            entries={50}
            // maxHeight="70vh"
            multi
            // selectable
            data={{
              ...finalData,
              rows: filteredRows
            }
            }
          />
        </div>
      </div>
      {addHundGroup && (
        <PopupLoaderNew
          title={"Add Hunt Group"}
          content={<AddHuntGroup onClose={togglePopup}
            ref={addHuntRef}
            setIsloading={setisLoading}
          />}
          onShow={setAddHundGroup}
          onClose={togglePopup}
          onSave={handleClick}
          isloading={isLoading}
          flag = {1}
        />
      )}
      {deleteHGroup && (
        <PopupLoaderNew
          title={"Remove Hunt Group"}
          content={<DeleteHuntGroup 
          groupId={selectedGroupId} 
          onClose={dtogglePopup} 
          ref={addHuntRef}
          setIsloading={setisLoading}
          assocCFData = {assocCallFlows}
          assocLunaHops = {assocLunaHops}
          />}
          onShow={setDeleteHGroup}
          onClose={dtogglePopup}
          onSave={handleClick}
          isloading={isLoading}
          flag={assocCallFlows.length == 0 && assocLunaHops.length == 0 ? 4 : 10}
          hideClose={assocCallFlows.length == 0 && assocLunaHops.length == 0 ? false : true}
        />
      )}

      {isloading && (
        <>
          <div className="loadingclass">
            <MDBBtn disabled>
              <MDBSpinner
                size="sm"
                role="status"
                tag="span"
                className="me-2"
              />
              Loading...
            </MDBBtn>
          </div>
        </>
      )}

      {showExportWarning && (
        <ImportProgressWarning
          warningToggle={exportwarningToggle}
          setShowWarning={setShowExportWarning}
          onOk={exportwarningToggle}
          message={warningMessage}
        />
      )}

      {showImpExpRedirect && (
        <ImpExpRedirectPopup
          onProceed={() => {
            setShowImpExpRedirect(false);
            setfirstRequest(true);
            importuserToggle();
          }}
          onCancel={() => setShowImpExpRedirect(false)}
        />
      )}

      <MDBModal open={importUser} onClose={() => setimportUser(false)} tabIndex='-1'>
        <MDBModalDialog size="fullscreen">
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>Import User Template</MDBModalTitle>
            </MDBModalHeader>
            <MDBModalBody className="pb-0">
              <ImportUser
                onClose={importuserToggle}
                setIsloading={setisLoading}
                onShow={setimportUser}
                show={importUser}
                firstRequest={firstRequest}
                setfirstRequest={setfirstRequest}
              />
            </MDBModalBody>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>

      {internalError && (<MDBAlert
        open
        className="alert-center"
        color="danger"
        autohide
        position="bottom-right"
        delay={3000}
      >Internal Server Error</MDBAlert>)}

      <Tooltip anchorSelect=".deleteToolTip" place="top" className="exampleTooltip">
        Remove
      </Tooltip>
    </>
  );
}




export async function getAssocCFDataByEntityIdNodeType(siteId, entityId, nodeType) {
  try {
    let apiResponse = await getAssociatedCFData(siteId, entityId, nodeType);
    let apiResBody = await apiResponse.json();
    return apiResBody;
  } catch (error) {
  }
  return [];
}